import { render, staticRenderFns } from "./LevelBackButton.vue?vue&type=template&id=3a61b238&scoped=true"
import script from "./LevelBackButton.vue?vue&type=script&lang=js"
export * from "./LevelBackButton.vue?vue&type=script&lang=js"
import style0 from "./LevelBackButton.vue?vue&type=style&index=0&id=3a61b238&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a61b238",
  null
  
)

export default component.exports